import Layer2 from './Base';

export default function StatisticalConcepts({ session }) {
  return <Layer2 page="Statistical Concepts" />;
}
